import React from 'react';
import { Colors } from '../../theme';

export default function CircularIcon({
    icon,
    color,
    backgroundColor,
    style,
    padding = 15,
}: {
    icon: React.ReactNode;
    color?: Colors;
    backgroundColor?: Colors | string;
    style?: React.CSSProperties;
    padding?: number;
}) {
    return (
        <div
            style={{
                color: color || Colors.darkNavy,
                backgroundColor: backgroundColor || Colors.mediumTerraCotta,
                padding: padding,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                aspectRatio: '1',
                flexShrink: 0,
                ...style,
            }}
        >
            {icon}
        </div>
    );
}
